import {
  Button,
  Checkbox,
  Dialog,
  FormControlLabel,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import CustomButton from "../../reusableComponents/CustomButton";
import { colorBrandObject } from "../../../constants/brandings";
import { sortArrayValue } from "../utils/utils";

const theme = createTheme({
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "black",
          "&$checked": {
            color: "black",
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "black",
          "&$checked": {
            color: "black",
          },
        },
      },
    },
  },
});

export default function StatusModal({
  openModal,
  onClose,
  sendDataToReportGenerated,
  statusTypeData,
}) {
  const [sortedStatusData,setSortedStatusData] = useState([])
  const [modalCheckboxArray, setModalCheckboxArray] = useState([]);
  const [selectedCheckboxArray, setSelectedCheckboxArray] = useState([]);
  const handleCheckboxChanges = (event) => {
    const checkboxValue = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedCheckboxArray((prev) => [...prev, checkboxValue]);
    } else {
      setSelectedCheckboxArray((prev) =>
        prev.filter((item) => item !== checkboxValue)
      );
    }
  };

  function submitCheckValue() {
    setModalCheckboxArray(selectedCheckboxArray);
    onClose();
  }

  useEffect(() => {
    sendDataToReportGenerated(modalCheckboxArray);
  }, [modalCheckboxArray]);

  const handleClearAllData = () => {
    setSelectedCheckboxArray([]);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      onClose();
    }
  };


  useEffect(() => {
    if(statusTypeData?.length ) {
      let sortedData = sortArrayValue(statusTypeData[0],"title")
      setSortedStatusData(sortedData)
    }
  },[statusTypeData])
  return (
    <Dialog open={openModal} className="reportsModal" onKeyDown={handleKeyDown}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "6px",
          padding: "24px 24px 0px 24px",
        }}
      >
        <Typography className="SemiboldTwenty font-black-highest">
          Status
        </Typography>
        <img
          src="/assets/ic_twotone-close.svg"
          alt="cross"
          onClick={() => onClose()}
          style={{ cursor: "pointer" }}
        />
      </div>
      <Typography
        className="labelRegular font-black-high"
        style={{ padding: "0px 24px" }}
      >
        Select your status
      </Typography>
      <div
        style={{
          marginTop: "20px",
          height: "282px",
          overflowY: "scroll",
          padding: "0px 24px",
        }}
      >
        <div
          className="row reportCheckbox"
          style={{
            marginLeft: "4px",
            marginRight: "0px",
          }}
        >
          {sortedStatusData?.map((item, idx) => {
            const isChecked = selectedCheckboxArray.includes(item?.value);
            return (
              <div className="col-6" key={idx}>
                <ThemeProvider theme={theme}>
                  <FormControlLabel
                    style={{ paddingBottom: "18px" }}
                    control={
                      <Checkbox
                        style={{
                          fontFamily: "Poppins",
                          fontWeight: "500",
                          fontSize: "14px",
                          height: "18px",
                          color: "rgba(36, 183, 170, 1)",
                          marginRight: "8px",
                        }}
                        sx={{
                          '& .MuiSvgIcon-root': {
                            color: colorBrandObject?.secondaryButtonColor,
                          },
                          '&.Mui-checked': {
                            color: colorBrandObject?.secondaryButtonColor,
                            '& .MuiSvgIcon-root': {
                              fill: colorBrandObject?.secondaryButtonColor,
                            },
                          },
                        }}
                        checked={isChecked}
                        value={item?.value}
                        name={item?.value}
                        onChange={handleCheckboxChanges}
                      />
                    }
                    label={item?.value}
                  />
                </ThemeProvider>
              </div>
            );
          })}
        </div>
      </div>
      <div
        style={{
          paddingBottom: "24px",
          paddingTop: "24px",
          display: "flex",
          justifyContent: "end",
          paddingRight: "24px",
          boxShadow: "0px -2px 8px 0px rgba(39, 39, 39, 0.15)",
        }}
      >
        <CustomButton
          variant={"outlined"}
          size={"sm"}
          type={"secondary"}
          text={"Clear All"}
          onClick={handleClearAllData}
        />
        <div style={{ marginLeft: "8px" }}>
          <CustomButton
            variant={"contained"}
            size={"sm"}
            type={"secondary"}
            text={"Apply"}
            onClick={() => submitCheckValue()}
          />
        </div>
      </div>
    </Dialog>
  );
}
